/*
 * Copyright (c) 2026.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */

/**
 * Auteur: Jelmer Jellema - Spin in het Web B.V
 * Gegenereerd met Claude Code (AI), 23-09-2026
 *
 * De dialoog waarin je een wachtwoordlink aanvraagt (golf 4e), de ng21-opvolger van het uib-modal uit
 * `app/states/login/wachtwoordvergeten.html`. Eén e-mailveld; het backend meldt niet of het adres
 * bestaat, dus de bevestiging zegt alleen dát er een mail onderweg is als het adres bekend was.
 */
import {ChangeDetectionStrategy, Component, inject, signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {SihwconfirmService} from 'sihw-ngx';
import {TaalService} from 'dynalearn-common/services/taal.service';
import {SessieService} from '../../../services/sessie.service';

@Component({
    selector: 'dl-wachtwoord-vergeten',
    templateUrl: './dl-wachtwoord-vergeten.component.html',
    styleUrls: ['./dl-wachtwoord-vergeten.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, TranslatePipe]
})
export class DlWachtwoordVergetenComponent {

    /** De sessie doet de call. */
    private readonly sessie = inject(SessieService);

    /** De taal waarin het backend de mail stelt. */
    private readonly taal = inject(TaalService);

    private readonly translate = inject(TranslateService);
    private readonly sihwconfirm = inject(SihwconfirmService);
    private readonly modalRef = inject(BsModalRef);

    /** Het ingevulde adres. */
    protected gebruikersnaam = '';

    /** Of de aanvraag onderweg is; dan doet de knop niets meer. */
    protected readonly bezig = signal(false);

    /**
     * Vraagt de link aan en bevestigt dat er (mogelijk) een mail onderweg is.
     */
    protected async vraagLink(): Promise<void> {
        this.bezig.set(true);
        try {
            await this.sessie.stuurWachtwoordlink(this.gebruikersnaam, this.taal.taal());
            await this.sihwconfirm.ok(
                this.translate.instant('WACHTWOORDVERGETEN.VRAAGLINK.VERZONDEN'),
                this.translate.instant('WACHTWOORDVERGETEN.VRAAGLINK.MAILUITLEG'),
                this.translate.instant('ALGEMEEN.OK'));
            this.modalRef.hide();
        } finally {
            this.bezig.set(false);
        }
    }

    /**
     * Sluit de dialoog zonder iets te vragen.
     */
    protected sluit(): void {
        this.modalRef.hide();
    }
}
